import { AwsRum, AwsRumConfig } from 'aws-rum-web';

/** Tags our events; the ITSS app monitors may be shared with other apps. */
const APP_NAME = 'cssd';

const enabled = import.meta.env.VITE_RUM_ENABLED === 'true';
const applicationId = import.meta.env.VITE_RUM_APPLICATION_ID;
const identityPoolId = import.meta.env.VITE_RUM_IDENTITY_POOL_ID;
const guestRoleArn = import.meta.env.VITE_RUM_GUEST_ROLE_ARN;
const endpoint = import.meta.env.VITE_RUM_ENDPOINT;
const region = import.meta.env.VITE_RUM_APPLICATION_REGION;

/** `undefined` until first use; `null` when disabled or initialization failed. */
let awsRum: AwsRum | null | undefined;

/**
 * Initializes RUM on first use rather than at app load: constructing `AwsRum`
 * starts a session and authenticates against Cognito, which only pages that
 * actually record an event should pay for (or be broken by).
 */
function getRum(): AwsRum | null {
  if (awsRum !== undefined) return awsRum;
  awsRum = null;

  if (!enabled || !applicationId || !identityPoolId || !guestRoleArn || !endpoint || !region) {
    return awsRum;
  }

  try {
    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      identityPoolId,
      guestRoleArn,
      endpoint,
      telemetries: [], // No automatic telemetry — we only record custom events
      allowCookies: false,
      enableXRay: false,
    };

    awsRum = new AwsRum(applicationId, '1.0.0', region, config);
  } catch (err) {
    console.error('Failed to initialize AWS RUM:', err);
  }
  return awsRum;
}

/** Record a hit to an unrouted (404) path for legacy link detection. */
export function recordUnroutedPath(path: string): void {
  const rum = getRum();
  if (!rum) return;

  try {
    rum.recordEvent('unrouted_path_hit', { app: APP_NAME, path });
  } catch (err) {
    console.error('Failed to record RUM event:', err);
  }
}
